export default function Header() {
  return (
    <div
      className={`myContainer flex justify-center lg:justify-between items-center !py-6`}
    >
      <img className={`w-32 lg:max-w-[166px]`} src="./logo.png" alt="Logo" />

      {/* <div
          className={`flex justify-center items-center gap-1 cursor-pointer`}
        >
          <span className={`text-lg`}>خدمات</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M12.6667 6L8.00004 10L3.33337 6"
              stroke="#262626"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <Link
          to={`https://app.gameandgrow.com/terms`}
          className={`text-lg`}
          target="_blank"
        >
          قوانین بازی
          </Link> */}
      <a href="#footer" className="text-lg text-myNeutral26 max-lg:hidden">
        تماس باما
      </a>
      <div className={`flex items-center gap-4 max-lg:hidden`}>
        <a
          download={`بروشور شهروندی.pdf`}
          href={`https://gameandgrow.com/files/%D8%B4%D9%87%D8%B1%D9%88%D9%86%D8%AF%DB%8C/all.pdf`}
        >
          <button className="btn text-white bg-gradient-to-b from-[#0D9D69] to-[#69BC4D] w-36 lg:w-[164px] border-none rounded-xl">
            دانلود بروشور شهروندی
          </button>
        </a>
        <a
          download={`بروشور سازمانی.pdf`}
          href={`https://gameandgrow.com/files/%D8%B3%D8%A7%D8%B2%D9%85%D8%A7%D9%86%DB%8C/all.pdf`}
        >
          <button className="btn text-white bg-gradient-to-r from-[#499FC6] to-[#0C3E69] w-36 lg:w-[164px] border-none rounded-xl">
            دانلود بروشور سازمانی
          </button>
        </a>
      </div>
    </div>
  );
}
